import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { InfoBar } from "../../shared/infoBar";
import { ErrorHeader } from "../../shared/errorHeader";
import { CreateOrgPanel } from "./createOrgPanel";
import { useApiCall } from "../../hooks/useApiCall";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";
import { createOrganizationApi } from "../../api/organizationApi";
import { useNavigate } from "react-router-dom";
import { AdminUser, CreateOrganizationCommand } from "../../api/models/organization";
import { getIsSuperAdmin } from "../../api/userApi";


export const AddOrganizationPage: React.FC = (): JSX.Element => {

        const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
        const [isLoading, setIsLoading] = useState<boolean>(false);
        const createOrgApiRequest = useApiCallWithAuth(createOrganizationApi);

        const navigate = useNavigate();

        async function handleCreateOrg(name: string, isPublic:boolean, adminUsers?: AdminUser[]) {

            const createOrgCommand:CreateOrganizationCommand = {
                name: name,
                isPublic: isPublic,
                adminUsers: adminUsers
            };

            setIsLoading(true);
            setErrorMessage(undefined);
            await createOrgApiRequest.request(createOrgCommand);
            navigate(`/orgs`);
        }

function mainContent() {
        return (
            <Box sx={{ width: 600 }}>
                <h1>Add Organization Page</h1>

                <CreateOrgPanel isLoading={isLoading} onSubmit={handleCreateOrg}/>
            </Box>
        );
    }

    return (
        <Box>
            <InfoBar navigateUrl={`/orgs`}  />
            <ErrorHeader errorMessage={errorMessage} />
           
            
            {mainContent()}
        </Box>
    );

      
}